export default __webpack_public_path__ + "static/media/ic_hospital.95d5841a.svg";